import * as React from 'react';

import { Root } from './styled';
const alfaLogoPath = require('./assets/banks-logo/svg/alfabank.svg');
const avangardLogoPath = require('./assets/banks-logo/avangard.png');
const binbankLogoPath = require('./assets/banks-logo/binbank.png');
const gazprombankLogoPath = require('./assets/banks-logo/gazprobank.png');
const modulebankLogoPath = require('./assets/banks-logo/svg/modulbank.svg');
const openLogoPath = require('./assets/banks-logo/svg/open.svg');
const promsvyazbankLogoPath = require('./assets/banks-logo/promsvyazbank.png');
const raiffeisenLogoPath = require('./assets/banks-logo/raiffeisen.png');
const sberbankLogoPath = require('./assets/banks-logo/svg/sberbank.svg');
const smpbankLogoPath = require('./assets/banks-logo/smpbank.png');
const tinkoffLogoPath = require('./assets/banks-logo/svg/tinkoff.svg');
const tochkaLogoPath78 = require('./assets/banks-logo/78x78/tochka.png');
const tochkaLogoPath24 = require('./assets/banks-logo/24x24/tochka.png');
const ubrirLogoPath = require('./assets/banks-logo/ubrir.png');
const uralsibLogoPath78 = require('./assets/banks-logo/78x78/uralsib.png');
const uralsibLogoPath24 = require('./assets/banks-logo/24x24/uralsib.png');
const vtbSquareLogoPath = require('./assets/banks-logo/svg/vtb-square.svg');
const vtbLogoPath = require('./assets/banks-logo/svg/vtb.svg');
const defaultBankLogoPath = require('./assets/register-icon/bank.svg');
const defaultCashLogoPath = require('./assets/register-icon/cash.svg');


export type AccountIconProps = {
	isBank: boolean;
	bankName: string;
	width?: number;
	height?: number;
	bigSize?: boolean;
};

const AccountIcon: React.SFC<AccountIconProps> = (props) => {
	const {
		isBank,
		bankName,
		width,
		height
	} = props;
	const isSquare = width === height;
	const getBankLogo = (isBank: boolean, bankName: string) => {
		if (/(АЛЬФА-БАНК)|(АЛЬФАБАНК)/ig.test(bankName)) {
			return alfaLogoPath;
		}
		if (/АВАНГАРД/ig.test(bankName)) {
			return avangardLogoPath;
		}
		if (/БИНБАНК/ig.test(bankName)) {
			return binbankLogoPath;
		}
		if (/ГПБ/ig.test(bankName)) {
			return gazprombankLogoPath;
		}
		if (/МОДУЛЬБАНК/ig.test(bankName)) {
			return modulebankLogoPath;
		}
		if (/ТОЧКА/ig.test(bankName)) {
			return width === 24 ? tochkaLogoPath24 : tochkaLogoPath78;
		}
		if (/ОТКРЫТИЕ/ig.test(bankName)) {
			return openLogoPath;
		}
		if (/ПРОМСВЯЗЬБАНК/ig.test(bankName)) {
			return promsvyazbankLogoPath;
		}
		if (/РАЙФФАЙЗЕНБАНК/ig.test(bankName)) {
			return raiffeisenLogoPath;
		}
		if (/СБЕРБАНК/ig.test(bankName)) {
			return sberbankLogoPath;
		}
		if (/СМП БАНК/ig.test(bankName)) {
			return smpbankLogoPath;
		}
		if (/ТИНЬКОФФ БАНК/ig.test(bankName)) {
			return tinkoffLogoPath;
		}
		if (/УБРИР/ig.test(bankName)) {
			return ubrirLogoPath;
		}
		if (/УРАЛСИБ/ig.test(bankName)) {
			return width === 24 ? uralsibLogoPath24 : uralsibLogoPath78;
		}
		if (/ВТБ/ig.test(bankName)) {
			return isSquare ? vtbSquareLogoPath : vtbLogoPath;
		}

		if (!isBank) {
			return defaultCashLogoPath;
		}

		return defaultBankLogoPath;
	};

	let logoPath = getBankLogo(isBank, bankName);

	return (
		<Root
			resource={logoPath}
			width={width}
			height={height}
		/>
	);
};

export default AccountIcon;
